/* eslint-disable react/prop-types */
import React from "react";
import "../ErrorHandling/error.scss";
import { arrayToString } from "../utils/formatting";

class ErrorBoundary_component extends React.Component { 

    constructor(props){
    super(props);
    this.state = {hasError : false}
    }

    static getDerivedStateFromError(error){
        // Update state so the next render will show the fallback UI.
        console.warn(error);
        return {hasError: true}
    }
       componentDidCatch(error,info){
        // You can also log the error to an error reporting service
        console.error(error,info);
        
        let errors = document.querySelectorAll(".errorCode");
        let errorCodes = [];
        // console.log(errors);
        errors.forEach(function(item){
            let er = item.innerText;
            er = er.replace(/\[(.+? )\]/g, '');
            if(!errorCodes.includes(er)){   
                errorCodes.push(er);
            }
        })
        console.log(errorCodes);
       sessionStorage.setItem("errorCodes", errorCodes);
       if(window.location.href.indexOf("localhost") == -1){
        throw new Error(error); 
       }
        // throw new Error(info);
    }
    render(){
        if(this.state.hasError){
              // You can render any custom fallback UI
            return this.props.fallback;
        }
        return this.props.children;
    }
}

export default ErrorBoundary_component;